import { isNumber } from 'lodash';
import { theme } from 'src/utils/theme';

import { CustomTooltipProps } from './CustomTooltip.interface';

export const getTooltipStyles = (
  props: Pick<
    CustomTooltipProps,
    'isSecondaryTooltip' | 'fontSize' | 'isHidden' | 'width'
  >,
) => {
  return {
    arrow: {
      sx: {
        color: props.isSecondaryTooltip
          ? theme.tooltip.secondary.info
          : theme.tooltip.primary.info,
      },
    },
    tooltip: {
      sx: {
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingLeft: '8px',
        fontSize: isNumber(props.fontSize) ? `${props.fontSize}px` : '10px',
        lineHeight: '14px',
        fontWeight: 500,
        'white-space': 'pre-wrap',
        backgroundColor: (props.isSecondaryTooltip
          ? theme.tooltip.secondary.info
          : theme.tooltip.primary.info) as string,
        color: (!props.isSecondaryTooltip
          ? theme.palette.primary.contrastText
          : theme.palette.brand.charcoal) as string,
        ...(props.isHidden && { display: 'none' }),
        ...(props.isHidden === false && { width: '130px' }),
        ...(props.width
          ? { maxWidth: `${props.width}px` }
          : { maxWidth: '300px' }),
      },
    },
  };
};
